import * as receipt from 'src/api/receipt'
import router from 'src/router'
import {
  SET_RECEIPT
} from 'src/store/mutation-types'

const setReceipt = ({commit}, receipt) => {
  commit(SET_RECEIPT, receipt)
}

const getReceiptDetail = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  receipt.getReceipt(configs.id, configs.params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(SET_RECEIPT, response.data)
    } else if (response.code === 404) {
      dispatch('toggleLoadding', false, {root: true})
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        body: 'Phiếu thu không tồn tại trên hệ thống',
        type: 'warning'
      }, {root: true})
      router.push({name: 'receipt'})
    } else {

    }
  })
}

export default{
  setReceipt,
  getReceiptDetail
}



// WEBPACK FOOTER //
// ./src/components/receipt/store/actions.js